export function getTooltipPropsAsObject(tooltipProp) {
    var tooltipProps = isTooltipObject(tooltipProp)
        ? tooltipProp
        : { text: tooltipProp };
    return tooltipProps;
}
function isTooltipObject(tooltipProp) {
    return typeof tooltipProp === 'object' && 'text' in tooltipProp;
}
//# sourceMappingURL=utils.js.map